import { render } from "./note-box.vue?vue&type=template&id=143b9f4c&scoped=true"
import script from "./note-box.vue?vue&type=script&lang=js"
export * from "./note-box.vue?vue&type=script&lang=js"

import "./note-box.vue?vue&type=style&index=0&id=143b9f4c&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143b9f4c"]])

export default __exports__